import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { HeaderNew } from '../../components/HeaderNew';
import { FooterNew } from '../../components/FooterNew';
import { useRouting } from '../../shared/use-routing';
import styles from './PublicLayout.css';

const cx = classnames.bind(styles);

function PublicLayout({ children }) {
    const { params } = useRouting();
    const isApp = Boolean(params.subscriptionId) || Boolean(params.orderId);

    return (
        <div className={cx('root', { secondary: isApp })}>
            {isApp ? <HeaderNew isApp className={cx('header', 'secondaryHeader')} /> : <HeaderNew />}
            {children}
            <FooterNew />
        </div>
    );
}

PublicLayout.propTypes = {
    children: PropTypes.any.isRequired
};

export {
    PublicLayout
};
